import { queryOptions } from "@tanstack/react-query";
import { fetchOccPageData } from "./pageDataClient";
import { pageDataKeys } from "./pageDataKeys";
import type { PageInitialDataResult } from "./pageInitialDataTypes";

export const CONTRACT_OVERVIEW_PAGE_ID = "my-account/contractOverview";

export const contractOverviewPageQueryOptions = () =>
  queryOptions({
    queryKey: pageDataKeys.contractOverview(),
    queryFn: () => fetchOccPageData<PageInitialDataResult<void>>(`/page-data/${CONTRACT_OVERVIEW_PAGE_ID}`),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });
